module.exports = __webpack_public_path__ + "img/GainAgility.4bc302b5.png";